import React, { useEffect, useState }  from 'react'
import cx from 'utils/classnames'
import {
    FaReplyAll,
} from 'react-icons/fa'
import { Link } from 'react-router-dom'
import Typography from 'entrada-ui/Typography'
import svg from './oops-bird.svg'
import styles from './styles.module.scss'

const Error = (props) => {
    return (
        <div className={styles.wrapper}>
            <img className={styles.img} src={svg} />
            <Typography className="text-bold" variant="h2">Oops! something went a bit wrong...</Typography>

            <div className="text-center mt-4 mb-4">
                <Link className={cx(styles.backBtn, 'btn btn-secondary')} to="/search">
                    <FaReplyAll /> Go back & try again
                </Link>
            </div>

        </div>
    )
}

export default Error
